export * from './create-edit-label-flags.component';
export * from './create-edit-label-flags.dialog';
export * from './label-flags.component';
export * from './label-flags.trans';